import DashboardService from '@/services/retailer/DashboardService.js'

import { errorMessage } from '@/utilities/helpers.js'

import { DASHBOARD_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const state = {
  dashboard: [],
  retailer_standing_type: 0,
  menuItemsBadgeCount: {},
  lastOrders: [],
  activeSeasonInfo: {},
  lastSeasonInfo: {},
  ranking: {}
}

export const mutations = {
  SET_DASHBOARD(state, dashboard) {
    state.dashboard = dashboard.data
  },
  SET_VALUE(state, parameters) {
    state[parameters.type] = parameters.value
  },
  SET_MENU_ITEMS_BADGE_COUNT(state, menuItemsBadgeCount) {
    state.menuItemsBadgeCount = menuItemsBadgeCount.data
  },
  SET_LAST_ORDERS(state, lastOrders) {
    state.lastOrders = lastOrders
  },
  SET_SEASON_INFO(state, seasonInfo) {
    state.activeSeasonInfo = seasonInfo.active_season
    state.lastSeasonInfo = seasonInfo.last_season
  },
  SET_RANKING(state, ranking) {
    state.ranking = ranking
  }
}

export const actions = {
  getDashboard({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      DashboardService.getDashboard(params)
        .then(response => {
          commit('SET_DASHBOARD', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getDashboardError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getDashboardMenuItemsBadgeCount({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      DashboardService.getDashboardMenuItemsBadgeCount()
        .then(response => {
          commit('SET_MENU_ITEMS_BADGE_COUNT', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: DASHBOARD_ERROR_MESSAGES.getDashboardMenuItemsBadgeCountError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getLastOrders({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      DashboardService.getLastOrders()
        .then(response => {
          commit('SET_LAST_ORDERS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSeasonInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      DashboardService.getSeasonInfo()
        .then(response => {
          commit('SET_SEASON_INFO', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getRanking({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      DashboardService.getRanking(params)
        .then(response => {
          commit('SET_RANKING', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  setValue({ commit }, parameters) {
    commit('SET_VALUE', parameters)
  }
}
